import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'

// import { hasAccess } from '../../../utils/auth'
import Dragula from '../../../shared/components/Dragula'
import PriceItem from '../PriceItem'
// import HelpText from '../../../shared/components/HelpText'

import './priceitemgroup.scss'
import '../PriceItem/priceitem.scss'

// Utils
import { translation } from '../../../utils/helpers'

// Elements
import TableContainer from '../../../shared/elements/tableContainer'
import TableExpand from '../../../shared/elements/tableExpand'
import TableHeader from '../../../shared/elements/tableHeader'
import TableRow from '../../../shared/elements/tableRow'
import HelpIcon from '../../../shared/elements/helpIcon'

class PriceItemGroup extends Component {
  constructor (props) {
    super(props)
    this.state = {
      config: {                       // Example config data
        itemIdField: 'TaskPriceId',   // Name of Id field for items in the list.
        itemOrderField: 'SortIndex',  // Name of field that will be used/set in drag/reorder operations
        itemOrderLockedField: 'SortIndexLocked',  // Field to use when determining if an item can be moved or not
        editable: true,
        whitebox: true,
        draggable: true,              // Allow and display drag column
        title: 'No title',            // Text or dictionary key
        groupCss: 'partitem__list',   // name of css class that will be applied to the UL
        itemCss: 'taskpriceItem',     // name of css class that will be applied to each LI
        allowAdd: true,
        allowDelete: true,
        fields: [
          {
            name: 'TaskName',
            header: 123, // text or dictionary key
            type: 'text',
            editable: false,  // editable for existing entries or not
            hide: false,
            css: 'taskname-class'
          },
          {
            name: 'AE',
            header: 'LU',
            type: 'ae',
            editable: true,
            hide: false,
            css: ''
          },
          {
            name: 'Gross',
            header: 'Bruttoo',
            type: 'currency',
            editable: false,
            hide: false,
            css: ''
          },
          {
            name: 'DropDownExample',
            header: 'Dropdown',
            type: 'select',
            options: [{0: 'First'}, {1: 'Second'}], // if 'options' is a function, it is expected to take field-name as argument and return an array of option values
            editable: false,
            hide: false,
            css: ''
          }
        ],
        newItemInputs: ['TaskName', 'AE'],  // Open fields for new entries
        groupField: 'PartItemId'            // This field will be pre-filled from 'groupId' from provided props
      },
      items: []
    }
    this.dragula = null
    this.stateFromProps = this.stateFromProps.bind(this)
    this.enableScroll = this.enableScroll.bind(this)
    this.disableScroll = this.disableScroll.bind(this)
    // this.canScroll = true
    this.appElement = document.getElementById('app')
    this.canScroll = true
  }

  stateFromProps (props) {
    let state = this.state
    if (props.config !== undefined && props.config !== null) {
      // config is allowed to be either an object or a function
      if (typeof props.config === 'function') {
        state.config = props.config()
      } else {
        state.config = props.config
      }
    }
    if (props.items === undefined || props.items === null) {
      state.items = []
    } else {
      state.items = props.items
    }

    return state
  }

  componentDidMount () {
    let state = this.stateFromProps(this.props)
    this.setState({...state})
    setTimeout(() => this.setupDragula(), 100)
    this.enableScroll()
  }

  componentWillUnmount () {
    this.enableScroll()
  }

  componentWillReceiveProps (newProps) {
    let state = this.stateFromProps(newProps)
    this.setState({...state})
  }

  setupDragula () {
    if (this.state.config.draggable && this.state.config.editable) {
      var container = ReactDOM.findDOMNode(this).getElementsByClassName('drag_container')[0]
      var options = {
        direction: 'vertical',
        revertOnSpill: true,
        // mirrorContainer: container,
        ignoreInputTextSelection: true,
        accepts: (el, target, source, sibling) => {
          if (target !== source || sibling === null) return false
          // if (sibling.className.contains('gu-mirror')) return false
          let names = sibling.className.split(' ')
          for (let c = 0; c < names.length; c++) {
            if (['priceitem_header', 'gu-mirror', 'priceitem_nomove'].includes(names[c])) {
              return false
            }
          }
          return true
        },
        invalid: (el, handle) => {
          let isInvalid = (['hint--bottom', 'workers', 'buttons', 'priceitem_static', 'priceitem_header'].includes(handle.className))
          return isInvalid
        },
        moves: (el, container, handle) => {
          return handle.classList.contains('handle')
        }
      }

      this.dragula = new Dragula([container], options)
      .on('drag', (el, source) => {
      //   //this.dragula.on('drag', () => {})
        this.disableScroll()
      })
      .on('drop', (el) => {
        // this.enableScroll()
        this.enableScroll()
        let newPosition = -1
        // Determine new index of element in drop target.
        let index = el.dataset.index
        var allItems = ReactDOM.findDOMNode(this).getElementsByClassName('drag_container')[0].children
        for (var i = 0; i < allItems.length; i++) {
          if (el === allItems[i]) {
            newPosition = i
            break
          }
        }
        if (newPosition !== -1) {
          // console.log('moved ', this.state.items[index], 'to', newPosition)
          if (this.props.onDragged !== undefined && this.props.onDragged !== null) {
            this.props.onDragged(this.state.items[index], newPosition)
          }
        }
      })
      .on('dragend', (el, container) => {
        this.enableScroll()
        // this.dragula.on('drag', (el, source) => {
        //   // this.dragula.on('drag', () => {})
        //   // this.disableScroll()
        // })
      })
    } else {
      // Destroy dracula if he exist here
      if (this.dragula !== null) {
        this.dragula.destroy()
        this.enableScroll()
      }
    }
  }

  enableScroll () {
    // console.log('enable scroll')
    if (!this.canScroll) {
      if (this.appElement.classList.contains('lock-screen')) {
        this.appElement.classList.remove('lock-screen')
      }
      this.canScroll = true
    }
  }

  disableScroll () {
    // console.log('disable scroll')
    if (this.canScroll) {
      if (!this.appElement.classList.contains('lock-screen')) {
        this.appElement.classList.add(['lock-screen'])
      }
      this.canScroll = false
    }
  }

  generateColWidths (fields, hasDragColumn, hasAction) {
    let cols = ''

    if (hasDragColumn) {
      cols += 'min-content '
    }

    cols += fields.filter(f => !f.hide)
      .map(f =>
        f.col ? f.col : 1
      ).join('fr ') + 'fr'

    if (hasAction) {
      cols += ' 27px'
    }

    return cols
  }

  render () {
    let items = this.state.items
    // let boxCss = this.state.config.whitebox ? 'white__box' : ''
    let groupCss = this.state.config.groupCss
    let itemIdField = this.state.config.itemIdField
    let title = this.props.title
    if (title === undefined || title === null) {
      title = this.state.config.title
    }
    if (typeof title === 'number') {
      title = translation(title)
    }
    let hasTitle = title !== undefined && title !== null
    if (groupCss === undefined) {
      groupCss = ''
    }

    const renderItem = (val, key) => {
      return (
        <PriceItem
          item={val}
          config={this.state.config}
          key={itemIdField + '_' + val[itemIdField]}
          itemClass={this.props.itemClass}
          disabled={this.props.disabled}
          onDelete={this.props.onDelete}
          onUpdate={this.props.onUpdate}
          generateColWidths={this.generateColWidths}
          groupId={this.props.groupId}
          index={key} />
      )
    }

    const renderAddItem = () => {
      return (
        <PriceItem
          item={null}
          config={this.state.config}
          key={itemIdField + '_new'}
          disabled={this.props.disabled}
          onAdd={this.props.onAdd}
          generateColWidths={this.generateColWidths}
          groupId={this.props.groupId}
          index={null} />
      )
    }

    const renderHeader = () => {
      if (this.state.config.fields === undefined) return
      let helpText = this.state.config.headerHelp
      let hasHeaderHelp = helpText !== undefined && helpText !== null
      if (typeof helpText === 'number') helpText = translation(helpText)

      const renderHeaderItem = (field, key) => {
        if (field.hide === true) return null
        let header = field.header
        if (typeof header === 'number') header = translation(header)
        if (field.headerAppend !== undefined && field.headerAppend !== null) header += field.headerAppend

        let ariaLabel = field.ariaLabel
        if (typeof ariaLabel === 'number') ariaLabel = translation(ariaLabel)
        let hasAria = ariaLabel !== undefined && ariaLabel !== null

        let ariaHintClass = ''
        if (hasAria && field.ariaHintClass !== undefined && field.ariaHintClass !== null) {
          ariaHintClass = field.ariaHintClass
        }

        return (
          <span className={ariaHintClass} aria-label={hasAria ? ariaLabel : null} key={key}>
            {header}
          </span>
        )
      }

      const shouldRenderDragColumn = this.state.config.draggable && this.state.config.editable
      const hasAction = this.state.config.editable && (this.state.config.allowDelete || this.state.config.allowAdd)
      const cols = this.generateColWidths(this.state.config.fields, shouldRenderDragColumn, (hasAction || hasHeaderHelp))

      return (
        <li className='priceitem priceitem_static priceitem_header'>
          <TableRow header cols={cols}>
            {shouldRenderDragColumn && <div className='dragcolumn' />}
            {this.state.config.fields.map(renderHeaderItem)}
            {hasHeaderHelp && <HelpIcon helpText={translation(helpText)} />}
          </TableRow>
        </li>
      )
      // return (
      //   <li className='clearfix form priceitem priceitem_static priceitem_header'>
      //     {this.state.config.draggable && this.state.config.editable && <div className='dragcolumn' />}
      //     {this.state.config.fields.map(renderHeaderItem)}
      //     {hasHeaderHelp && headerHelp}
      //   </li>
      // )
    }

    const renderTitleHelp = () => {
      let text = this.state.config.titleHelp
      if (text === undefined || text === null) return null
      if (typeof text === 'number') text = translation(text)

      return text
      // return (<HelpText className='helpText' text={text} left />)
    }

    const renderContent = () => {
      return (
        <ul className='drag_container'>
          {renderHeader()}
          {items.map(renderItem)}
          {this.state.config.allowAdd && this.state.config.editable && renderAddItem()}
        </ul>
      )
    }

    if (this.state.config.whitebox) {
      return (
        <TableContainer fullWidth>
          <TableExpand>
            {hasTitle && (
              <TableHeader>
                <span>
                  {title}
                  <HelpIcon helpText={renderTitleHelp()} />
                </span>
              </TableHeader>
            )}

            {renderContent()}
          </TableExpand>
        </TableContainer>
      )
    }

    return (
      <div>
        {hasTitle && (
          <TableHeader simple>
            <span>
              {title}
              <HelpIcon helpText={renderTitleHelp()} />
            </span>
          </TableHeader>
        )}

        {renderContent()}
      </div>
    )

    // const renderContent = () => {
    //   return (
    //     <ul className='drag_container'>
    //       {renderHeader()}
    //       {items.map(renderItem)}
    //       {this.state.config.allowAdd && this.state.config.editable && renderAddItem()}
    //     </ul>
    //   )
    // }

    // if (this.state.config.whitebox) {
    //   return (
    //     <Panel title={hasTitle && title} helpText={hasTitle && renderTitleHelp()}>
    //       {renderContent()}
    //     </Panel>
    //   )
    // }

    // return (
    //   <div>
    //     {hasTitle && <Header text={title} helpText={renderTitleHelp()} />}
    //     {renderContent()}
    //   </div>
    // )
  }
}

PriceItemGroup.propTypes = {
  auth: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { })(PriceItemGroup)



// WEBPACK FOOTER //
// ./src/app/pages/Prices/PriceItemGroup/index.js